<boi-text-input [maxLength]="15" [labelName]="referenceDataLabels.PostcodeId" [(ngModel)]="address.Postcode"
  [forceRequired]="address.CountryTypeCode === referenceDataOptionLists.CountryTypeUk"
  (blurEventChange)="postcodeToUpper()" [validationErrors]="validationErrors"
  [validationPropertyNames]="['Address.Postcode']" name="postCode" [forceRequired]="true"
  [cssClasses]="'label-left label-weight-bold label-font-size-13 field-input-210-34 vo-address-input'">
</boi-text-input>

<ng-container *ngIf="isPostCodeInvalid">
  <p class="error-message" [innerHtml]="referenceDataLabels.AddressSearchFailMessage | localizeLabel"></p>
</ng-container>

<div class="buttons__bar buttons__bar_right mt-12 pr-10">
  <button (click)="openAddressFinder()" [innerHTML]="referenceDataLabels.FindAddressId | localizeLabel"
    class="primary-button" [disabled]="!address.Postcode"></button>
</div>


<div class="address-fields">
  <boi-text-input [maxLength]="40" [labelName]="referenceDataLabels.AddressLine1Mandatory"
    [(ngModel)]="address.AddressLine1" [validationErrors]="validationErrors"
    [validationPropertyNames]="['Address.AddressLine1']" name="line1" required="true">
  </boi-text-input>

  <boi-text-input [maxLength]="40" [labelName]="referenceDataLabels.AddressLine2" [(ngModel)]="address.AddressLine2"
    [validationErrors]="validationErrors" [validationPropertyNames]="['Address.AddressLine2']" name="line2">
  </boi-text-input>

  <boi-text-input [maxLength]="40" [labelName]="referenceDataLabels.AddressLine3" [(ngModel)]="address.AddressLine3"
    [validationErrors]="validationErrors" [validationPropertyNames]="['Address.AddressLine3']" name="line3">
  </boi-text-input>

  <boi-text-input [maxLength]="40" [labelName]="referenceDataLabels.CountyId" [(ngModel)]="address.County"
    [validationErrors]="validationErrors" [validationPropertyNames]="['Address.County']" name="county">
  </boi-text-input>
</div>

<ng-container *ngIf="isFindAddressOpen">
  <boi-postal-address-finder [data]="address.Postcode" (isPostCodeInvalid)="postCodeSearchError($event)"
    [(opened)]="isFindAddressOpen" (openedChange)="isFindAddressOpenChange.emit($event)"
    (addressSelected)="selectAddress($event)"></boi-postal-address-finder>
</ng-container>
